import { LogOut, Menu, UserRound } from "lucide-react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { postJson } from "../api";
import type { SessionUser } from "../types";

export function Header({ user, showCreateAlert = true, onSignOut }: { user: SessionUser | null; showCreateAlert?: boolean; onSignOut: () => void }) {
  const navigate = useNavigate();
  const signOut = async () => {
    try {
      await postJson("/api/auth/sign-out", {});
      onSignOut();
      navigate("/");
    } catch (error) {
      console.error("Unable to sign out", error);
    }
  };
  return (
    <header className="site-header">
      <Link to="/" className="wordmark">Austin Home Permits</Link>
      <nav aria-label="Primary navigation">
        <NavLink to="/">Explore</NavLink>
        <NavLink to="/about">About</NavLink>
      </nav>
      <div className="header-actions">
        <Link className="sign-in" to={user ? (user.isAdmin ? "/admin" : "/profile") : "/sign-in"}><UserRound size={18} />{user ? <span><small>Signed in</small>{user.email}</span> : "Sign in"}</Link>
        {user ? <button type="button" className="header-sign-out" onClick={signOut}><LogOut size={16} />Sign out</button> : null}
        {showCreateAlert ? <Link className="button primary" to="/alerts/new">Create an alert</Link> : null}
      </div>
      <div className="mobile-actions">
        <Link to={user ? (user.isAdmin ? "/admin" : "/profile") : "/sign-in"} aria-label={user ? `Signed in as ${user.email}` : "Sign in"}><UserRound /></Link>
        {user ? <button type="button" className="mobile-sign-out" onClick={signOut} aria-label="Sign out"><LogOut /></button> : null}
        <button className="mobile-menu" aria-label="Open navigation"><Menu /></button>
      </div>
    </header>
  );
}
